import {Typography, TypographyProps} from '@mui/material';

const ListItemTitle: React.FC<TypographyProps> = ({children, ...rest}) => (
  <Typography variant="h4" noWrap {...rest}>
    {children}
  </Typography>
);

export default ListItemTitle;
